var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('payments_stat')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('payments_per_year')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('payments_data_grid')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }